import React from 'react';
import { cn } from 'lib/utils';

type WrapperBaseProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'none' | 'page-full' | 'header';
};

export type WrapperProps<C extends React.ElementType> = WrapperBaseProps & {
  as?: C;
} & Omit<React.ComponentPropsWithoutRef<C>, keyof WrapperBaseProps | 'as'>;

const Wrapper = <C extends React.ElementType = 'div'>({
  as,
  children,
  className: classNameProp,
  variant = 'page-full',
  ...rest
}: WrapperProps<C>) => {
  const Component = as || 'div';

  const className = cn(
    'mx-auto w-full',
    {
      'max-w-360 px-wrapper-page-full-x': variant === 'page-full',
      'max-w-350 px-wrapper-header-x': variant === 'header',
    },
    classNameProp
  );

  return (
    <Component {...{ className }} {...rest}>
      {children}
    </Component>
  );
};

export default Wrapper;
